/* eslint-disable */
const content = {
  component: 'PageTypeA',
  cssClass: 'page-five',
  meta: {
    title: 'Charity Helps Improve Lives for Millions of India’s Elderly',
    description: 'By utilising cloud, HelpAge India were able to transform how they make an impact.',
    og: {
      type: 'website',
      title: 'Evolving charities with cloud—read more',
      description: `Technology enabled the charity to track inventory levels with exact accuracy, helping them to efficiently 
        distribute aid to the elderly across the country.`,
      image: require('../../assets/images/social/og_page5.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Discover how cloud enabled an Indian charity to transform lives.',
      description: `By utilising cloud, charity HelpAge India where able to keep track of inventory with exact accuracy, lowering costs 
        and helping them to efficiently distribute aid to the elderly.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page5.jpg')
    }
  },
  title: 'Charity Helps Improve Lives for Millions of India’s Elderly',
  heroImage: {
    preload: require('../../assets/images/backgrounds/page-five-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/page-five.jpg')
  },
  sections: [
    { 
      component: 'SectionQuote', 
      content: {
        quote: `Lack of access to primary healthcare is a key factor that’s pushing thousands of people into a spiral of declining productivity and diminished income and poverty.`,
        author: `Matthew Cherian`,
        position: `CEO, HelpAge India`,
        type: 'quote'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          HelpAge India has launched new programmes designed to help millions of senior citizens across the country combat degenerative illnesses, get out of poverty, and lead dignified, independent lives. A big challenge, however, is getting the right resources and supplies to them efficiently—and in time to make an impact.
        `,
        type: 'intro'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: null
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>Established in 1978, HelpAge India supplies millions of destitute seniors in India with everything from cataract surgeries and cancer therapies to milking goats and small farming equipment.</p>
          <p>The number of elderly in need has entered crisis mode in India, as millions of young adults leave their small towns and villages in order to start new lives in more economically promising urban centres. With increasing longevity in India, there are now 103 million elderly people in the country, 30 million of whom live alone, mostly in rural areas, where an estimated 25 million of them now live in poverty.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionImage', 
      content: {
        image: require('../../assets/images/content/page-five-a.png'),
        alt: '',
        type: 'image'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>HelpAge India recently launched a mobile healthcare delivery service, which aims to provide 5 million seniors (age 60 +) by 2020 with medicines, medical care, and supplies. But the logistical difficulties of delivering those goods and services have put the programme at risk.</p>
          <p>HelpAge India employs hundreds of call centre agents, relationship managers, and field personnel. And it can take them weeks to transfer details on donations, patients, and supplies from their mobile devices and paper notes into the charity’s on-premises enterprise resource planning applications. That manual work can cause serious delays in planning and scheduling resources.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionQuote', 
      content: {
        quote: `Without knowing exactly what our inventory and consumption levels are, we can’t get all of the medicines and supplies delivered in time to the people who desperately need them`,
        author: `Matthew Cherian`,
        position: `CEO, HelpAge India`,
        type: 'quote',
        backgroundImage: require('../../assets/images/backgrounds/page-five-sub-one.jpg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>However, by migrating its procurement and inventory data to Oracle cloud services “we’ll be able to use dashboards that give us real-time insight into how much inventory we have on hand, what we need to purchase, which vendors are giving us the best credit and what the status of the project is,” says Puneet Bali, HelpAge India COO. He estimates that the cloud migration will reduce the charity’s operating expenses by 14% and ultimately cut its inventory to near zero.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: require('../../assets/images/svg/medical.svg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>“We can’t justify administrative overhead when we need to account for every rupee we receive,” he says. “Donors want to see our efforts going to the elderly, not into our operations.”</p>
          <p>In contrast to many NGOs, HelpAge India, with the help of cloud tools, is starting to act more like a financial institution. It takes clients’ money as a trusted adviser, makes calculated investments, and anticipates a return for every rupee it receives.</p>
          <p>As the number of elderly people in India climbs from about 100 million today to an estimated 323 million by 2050, HelpAge India is on a mission to make that population a healthier one. By using cloud ERP applications to automate and account for all of its project functions, that’s a mission it’s better equipped to fulfil.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionCallToAction', 
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          { 
            image: require('../../assets/images/svg/lady-choices.svg'),
            copy: 'How does your CX stack up?',
            url: 'https://valuenavigator.oracle.com/benefitcalculator/faces/inputs?id=C7AB424C292E9A8D9CD29975AE0E40E9&source=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_CX_CB_ROI_CM_UK_C18_Q24&intcmp=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_CX_CB_ROI_CM_UK_C18_Q24',
            buttonCopy: 'Start your self-assessment'
          },
          { 
            image: require('../../assets/images/svg/click.svg'),
            copy: 'Discover smarter CX',
            url: 'https://go.oracle.com/LP=43623?qt=saas_ana_crm_SmarterCX&src1=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_CX_CT_QT_CM_UK_C18_Q24&intcmp=WWMK161025P00068:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_CX_CT_QT_CM_UK_C18_Q24',
            buttonCopy: 'Take our Quick Tour'
          }
        ],
        type: 'cta'
      }
    }
  ]
}

export default content;